import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class IpAddressProvider {

  constructor(public http: HttpClient) {}

  getIPAddress(){
    return this.http.get('https://api.ipify.org/?format=json')
  }
}



// WEBPACK FOOTER //
// ./src/providers/utility/ip-address/ip-address.ts